const START_DARK = 22;
const END_DARK = 6;

export function isDarkMode(date?: Date): boolean;
export function isDarkMode(hours?: number): boolean;
export function isDarkMode(arg: Date | number = new Date()): boolean {
  const hour = typeof arg === 'number' ? arg : arg.getHours();
  return hour >= START_DARK || hour < END_DARK;
}
